__turbopack_context__.v({
  "notificationItem": "NotificationItem-module___waKrW__notificationItem",
  "notificationItemUnread": "NotificationItem-module___waKrW__notificationItemUnread",
});
